(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.mbTabsInitialized === 'true') return;

      const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
      const panels = Array.from(section.querySelectorAll('[role="tabpanel"]'));
      if (!tabs.length) return;

      const activate = (tab, moveFocus = false) => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
          item.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });

        if (moveFocus) tab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index && !['Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          activate(tabs[nextIndex], true);
        });
      });

      section.dataset.mbTabsInitialized = 'true';
    };

    const initializeAll = (root = document) => {
      root.querySelectorAll('[data-mb-product-tabs]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
